import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border flex-shrink-0">
      <div className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4 overflow-x-hidden">
        <div className="text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} NAndroidEx. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
